import { SVGProps } from "react";

interface SpinnerProps extends SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
  strokeWidth?: number;
  duration?: number;
}

export function Spinner({
  size = 200,
  color = "#50CD89",
  strokeWidth = 30,
  duration = 2,
  ...props
}: SpinnerProps) {
  const gradientId = `spinner-gradient-${Math.random()
    .toString(36)
    .substr(2, 9)}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 200 200"
      width={size}
      height={size}
      {...props}
    >
      <linearGradient id={gradientId}>
        <stop offset="0" stopColor={color} stopOpacity="0" />
        <stop offset="1" stopColor={color} />
      </linearGradient>
      <circle
        fill="none"
        stroke={`url(#${gradientId})`}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeDasharray="0 44 0 44 0 44 0 44 0 360"
        cx="100"
        cy="100"
        r="70"
        transform-origin="center"
      >
        <animateTransform
          type="rotate"
          attributeName="transform"
          calcMode="discrete"
          dur={`${duration}s`}
          values="360;324;288;252;216;180;144;108;72;36"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  );
}
